import './_footer.scss';

export default () => {};
